import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import {
    TextStyle,
    Color,
    FontFamily,
    BackgroundColor,
} from '@tiptap/extension-text-style';
import { FontSize } from '@tiptap/extension-text-style/font-size';
import { Image } from '@tiptap/extension-image';

/**
 * @param {object} [options]
 * @param {boolean} [options.allowBase64Images]
 */
export function buildHtmlEditorExtensions(options = {}) {
    const allowBase64 = !!options.allowBase64Images;

    return [
        StarterKit.configure({
            heading: { levels: [1, 2, 3, 4, 5, 6] },
            underline: {},
            link: {
                openOnClick: false,
                autolink: true,
                linkOnPaste: true,
                HTMLAttributes: { rel: 'noopener noreferrer' },
            },
        }),
        TextStyle.configure({ mergeNestedSpanStyles: true }),
        Color.configure({ types: ['textStyle'] }),
        BackgroundColor.configure({ types: ['textStyle'] }),
        FontFamily.configure({ types: ['textStyle'] }),
        FontSize.configure({ types: ['textStyle'] }),
        TextAlign.configure({
            types: ['heading', 'paragraph'],
        }),
        Image.configure({
            inline: false,
            allowBase64,
            resize: false,
        }),
    ];
}

export { FONT_CHOICE_KEYS, FONT_FAMILY_CSS_BY_KEY, buildFontFamilySelectOptions } from './htmlEditorFontChoices.js';
